var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeartbeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heartbeat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#heartbeat_svg__b)",
    d: "M7.862 9.591l1.564-3.917.56 1.682h3.182c-.853 1.327-2.332 2.594-4.2 4.188-.533.456-1.101.941-1.698 1.464l-.27.237-.27-.237c-.597-.523-1.165-1.008-1.699-1.464C3.164 9.95 1.685 8.683.832 7.356h5.915l1.115 2.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#heartbeat_svg__c)",
    d: "M3.69.78C5.37.788 6.44 1.935 7 2.988 7.558 1.94 8.623.78 10.282.78h.028c1.952.015 3.586 1.684 3.685 3.798a4.348 4.348 0 01-.36 1.955h-3.058L9.496 3.285 7.779 7.587l-.525-1.053H.364A4.346 4.346 0 01.006 4.58C.105 2.465 1.738.796 3.69.78z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heartbeat_svg__b",
    x1: 11.318,
    x2: 5,
    y1: 12.062,
    y2: 3.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F75C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D22B24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heartbeat_svg__c",
    x1: 11.9,
    x2: 6.757,
    y1: 6.523,
    y2: -2.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F75C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D22B24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "heartbeat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 0H0v14h14z"
  })))));
}

export default __webpack_public_path__ + "./fonts/heartbeat.b77eb27e40fd0e82004bcd940c1ddcfc.svg";
export { SvgHeartbeat as ReactComponent };